import { Fragment, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RouteComponentProps } from "../../models/RouteComponent";
import { TabView, TabPanel } from 'primereact/tabview';
import { consultantUpdate } from "../../service/consultantService";
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Grid } from "@mui/material";
import { FormControl, FormLabel } from "@mui/joy";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { InputSwitch } from 'primereact/inputswitch';
import AccessLevelTree from "../../components/AccessLevelTree";
import { accessLevelAdd, accessLevelUpdate } from "../../service/accessLevelService";
import { Form, FormBuilder } from "dsf-form-builder";
import { getAll } from "../../service/employeeService";
import "dsf-form-builder/dist/style.css"
import { addForm, updateForm } from "../../service/formService";

export default function FormsBuilder(props: RouteComponentProps) {

  const navigate = useNavigate();

  const formRecord = props.form;

  console.log("formRecord == ", formRecord);

  const accessLevel = props.accessLevel;

  const clientID = props.session.client_id;

  const [form, setForm] = useState<any>(formRecord?.id ? { ...formRecord?.form, ...{ id: formRecord?.id } } : {
    items: []
  });

  console.log("formRecord?.form == ", formRecord?.form);

  const [formConfig, setFormConfig] = useState<any>()

  const toast = useRef(null as any);

  const record_id = formRecord?.id;

  async function updateAccessLevel(event: any) {
    console.log("event == ", event);
    setFormConfig(event);
  }

  let config = props.form?.config || {
    external_data: [
      {
        key: "employees",
        label: "Site Employees",
        options_func: async () => {
          return (await getAll()).map((item: any) => {
            return {
              value: item, label: item.full_name
            }
          }
          )
        }
      }
    ],
    forms: []
  };

  async function saveForm() {

    let UpdateConfig = {
      form: formConfig,
      config,
      name: formConfig.label
    }

    props.setGlobalLoader(true);
    if (record_id) {
      updateForm(UpdateConfig, record_id).then((r: any) => {
        toast.current.show({ severity: 'success', summary: 'Form Updated Successfully', life: 3000 });
        props.setGlobalLoader(false);
        navigate('/form-table');
      }).catch((err) => {
        toast.current.show({ severity: 'error', summary: 'Form Updated Failed', life: 3000 });
        props.setGlobalLoader(false);
      })
    } else {
      addForm(UpdateConfig).then((r: any) => {
        toast.current.show({ severity: 'success', summary: 'Form Created Successfully', life: 3000 });
        props.setGlobalLoader(false);
        navigate('/form-table');
      }).catch((err) => {
        toast.current.show({ severity: 'error', summary: 'Form Created Failed', life: 3000 });
        props.setGlobalLoader(false);
      })
    }
  }

  console.log("config == ", config);

  return (
    <Fragment>
      <br /><br />
      <FormBuilder form={form} onChange={updateAccessLevel} config={formRecord?.config || config} />
      <Button type="button" icon="pi pi-save" label="Save" className="p-button-outlined" size="small" style={{ position: 'absolute', fontSize: 'small', right: 70, top: 75, color: "#2dd36f" }} onClick={() => saveForm()} />

      <Toast ref={toast} />
    </Fragment>
  );
}